import { render, staticRenderFns } from "./add-node.html?vue&type=template&id=84c38032&scoped=true&"
import script from "./add-node.js?vue&type=script&lang=js&"
export * from "./add-node.js?vue&type=script&lang=js&"
import style0 from "./add-node.scss?vue&type=style&index=0&id=84c38032&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c38032",
  null
  
)

export default component.exports